module.exports = __webpack_public_path__ + "img/6.a14809d4.gif";